import { TranslationKeys as CoreTranslations } from '@pascal/pascal-core';

const GameTranslationKeys = {
  TITLE: 'TITLE',
  USER: 'USER',
  BET: 'BET',
  BET_1: 'BET_1',
  COEFFICIENT_1: 'COEFFICIENT_1',
  COEFFICIENT: 'COEFFICIENT',
  WIN: 'WIN',
  NO_BETS_TEXT: 'NO_BETS_TEXT',
  CASHOUT: 'CASH_OUT',
  AUTO_BET: 'AUTO_BET',
  ALL_IN: 'ALL_IN',
  AUTO_CASHOUT: 'AUTO_CASHOUT',
  CANCEL: 'CANCEL',
  BET_FOR_NEXT_ROUND: 'BET_FOR_NEXT_ROUND',
  TIME: 'TIME',
  TOTAL_ODD: 'TOTAL_ODD',
  FAIRNESS: 'FAIRNESS',
  ROUND_NUMBER: 'ROUND_NUMBER',
  FAIRNESS_P38: 'FAIRNESS_P38',
  FAIRNESS_P39: 'FAIRNESS_P39',
  FAIRNESS_P40: 'FAIRNESS_P40',
  FAIRNESS_P41: 'FAIRNESS_P41',
  FAIRNESS_P42: 'FAIRNESS_P42',
  FAIRNESS_P43: 'FAIRNESS_P43',
  FAIRNESS_P36: 'FAIRNESS_P36',
  FAIRNESS_P37: 'FAIRNESS_P37',
  FAIRNESS_P44: 'FAIRNESS_P44',
  FAIRNESS_P45: 'FAIRNESS_P45',
  FAIRNESS_P47: 'FAIRNESS_P47',
  FAIRNESS_P48: 'FAIRNESS_P48',
  FAIRNESS_P49: 'FAIRNESS_P49',
  FAIRNESS_P50: 'FAIRNESS_P50',
  FAIRNESS_P51: 'FAIRNESS_P51',
  FAIRNESS_P52: 'FAIRNESS_P52',
  FAIRNESS_P53: 'FAIRNESS_P53',
  FAIRNESS_P54: 'FAIRNESS_P54',
  MAX: 'MAX',
  MIN: 'MIN',
  DECIMAL: 'DECIMAL',
  YOU_HAVE_CASHED_OUT: 'YOU_HAVE_CASHED_OUT',
  YOUR_WIN: 'YOUR_WIN',
  CHAT: 'CHAT',
  GAME_RULES_P2: 'GAME_RULES_P2',
  GAME_RULES_P3: 'GAME_RULES_P3',
  GAME_RULES_P4: 'GAME_RULES_P4',
  GAME_RULES_P5: 'GAME_RULES_P5',
  GAME_RULES_P6: 'GAME_RULES_P6',
  GAME_RULES_P7: 'GAME_RULES_P7',
  GAME_RULES_P8: 'GAME_RULES_P8',
  GAME_RULES_P9: 'GAME_RULES_P9',
  GAME_RULES_P10: 'GAME_RULES_P10',
  GAME_RULES_P11: 'GAME_RULES_P11',
  GAME_RULES_P12: 'GAME_RULES_P12',
  GAME_RULES_P13: 'GAME_RULES_P13',
  GAME_RULES_P14: 'GAME_RULES_P14',
  GAME_RULES_P15: 'GAME_RULES_P15',
  GAME_RULES_P16: 'GAME_RULES_P16',
  GAME_RULES_P17: 'GAME_RULES_P17',
  GAME_RULES_P20: 'GAME_RULES_P20',
  GAME_RULES_P21: 'GAME_RULES_P21',
  GAME_RULES_P22: 'GAME_RULES_P22',
  GAME_RULES_P23: 'GAME_RULES_P23',
  GAME_RULES_P24: 'GAME_RULES_P24',
  GAME_RULES_P25: 'GAME_RULES_P25',
  GAME_RULES_P31: 'GAME_RULES_P31',
  GAME_RULES_P41: 'GAME_RULES_P41',
  OOPS: 'OOPS',
  CONNECTION_IS_LOST: 'CONNECTION_IS_LOST',
  FAIRNESS_P2: 'FAIRNESS_P2',
  FAIRNESS_P3: 'FAIRNESS_P3',
  FAIRNESS_P4: 'FAIRNESS_P4',
  FAIRNESS_P5: 'FAIRNESS_P5',
  FAIRNESS_P6: 'FAIRNESS_P6',
  FAIRNESS_P8: 'FAIRNESS_P8',
  FAIRNESS_P9: 'FAIRNESS_P9',
  FAIRNESS_P10: 'FAIRNESS_P10',
  FAIRNESS_P15: 'FAIRNESS_P15',
  FAIRNESS_P16: 'FAIRNESS_P16',
  FAIRNESS_P17: 'FAIRNESS_P17',
  FAIRNESS_P18: 'FAIRNESS_P18',
  FAIRNESS_P19: 'FAIRNESS_P19',
  FAIRNESS_P20: 'FAIRNESS_P20',
  FAIRNESS_P21: 'FAIRNESS_P21',
  FAIRNESS_P22: 'FAIRNESS_P22',
  FAIRNESS_P23: 'FAIRNESS_P23',
  FAIRNESS_P24: 'FAIRNESS_P24',
  FAIRNESS_P25: 'FAIRNESS_P25',
  FAIRNESS_P26: 'FAIRNESS_P26',
  FAIRNESS_P27: 'FAIRNESS_P27',
  FAIRNESS_P28: 'FAIRNESS_P28',
  FAIRNESS_P29: 'FAIRNESS_P29',
  FAIRNESS_P30: 'FAIRNESS_P30',
  FAIRNESS_P31: 'FAIRNESS_P31',
  FAIRNESS_P32: 'FAIRNESS_P32',
  FAIRNESS_P33: 'FAIRNESS_P33',
  FAIRNESS_P34: 'FAIRNESS_P34',
  FAIRNESS_P35: 'FAIRNESS_P35',
  CHECK_P1: 'CHECK_P1',
  CHECK_P2: 'CHECK_P2',
  CHECK_P3: 'CHECK_P3',
  CHECK_P4: 'CHECK_P4',
  CHECK_P5: 'CHECK_P5',
  CHECK_P6: 'CHECK_P6',
  GAME: 'GAME',
  STATISTICS: 'STATISTICS',
  FAIRNESS_P11: 'FAIRNESS_P11',
  FAIRNESS_P12: 'FAIRNESS_P12',
  FAIRNESS_P13: 'FAIRNESS_P13',
  FAIRNESS_P14: 'FAIRNESS_P14',
  PF_CHECKING_CALCULATOR: 'PF_CHECKING_CALCULATOR',
  LOADING_TEXT_1: 'LOADING_TEXT_1',
  LOADING_TEXT_2: 'LOADING_TEXT_2',
  LOADING_TEXT_3: 'LOADING_TEXT_3',
  LOADING_TEXT_4: 'LOADING_TEXT_4',
  NO_BETS: 'NO_BETS',
  NEW_BET: 'NEW_BET',
  WAITING_FOR_THE_NEXT_ROUND: 'WAITING_FOR_THE_NEXT_ROUND',
  GENERATE_NEXT_ROUND_SEED: 'GENERATE_NEXT_ROUND_SEED',
  PF_CALCULATOR: 'PF_CALCULATOR',
  PF: 'PF',
  SOUND: 'SOUND',
  MUSIC: 'MUSIC',
  ANIMATIONS: 'ANIMATIONS',
  GAME_RULES_P1: 'GAME_RULES_P1',
  FAIRNESS_P1: 'FAIRNESS_P1',
  BALANCE: 'BALANCE',
  DEPOSIT: 'DEPOSIT',
  YOU_ARE_AWAY: 'YOU_ARE_AWAY',
  MY_BETS: 'MY_BETS',
  ALL_BETS: 'ALL_BETS',
  TOP_WINS: 'TOP_WINS',
  LIVE_BETS: 'LIVE_BETS',
  HISTORY: 'HISTORY',
  HIGHEST: 'HIGHEST',
  SEARCH: 'SEARCH',
  CLEAR: 'CLEAR',
  PROVABLY_FAIRNESS: 'PROVABLY_FAIRNESS',
  NO_EMOJI_FOUND: 'NO_EMOJI_FOUND',
  SEARCH_RESULT: 'SEARCH_RESULT',
  FREQUENTLY_USED: 'FREQUENTLY_USED',
  FOOD_AND_DRINK: 'FOOD_AND_DRINK',
  ANIMALS_AND_NATURE: 'ANIMALS_AND_NATURE',
  PEOPLE_AND_BODY: 'PEOPLE_AND_BODY',
  ACTIVITY: 'ACTIVITY',
  TRAVEL_AND_PLACES: 'TRAVEL_AND_PLACES',
  OBJECTS: 'OBJECTS',
  SYMBOLS: 'SYMBOLS',
  FLAGS: 'FLAGS',
  CUSTOM: 'CUSTOM',
  EMOJI_CATEGORIES: 'EMOJI_CATEGORIES',
  DEFAULT_SKIN_TONE: 'DEFAULT_SKIN_TONE',
  LIGHT_SKIN_TONE: 'LIGHT_SKIN_TONE',
  MEDIUM_SKIN_TONE: 'MEDIUM_SKIN_TONE',
  DARK_SKIN_TONE: 'DARK_SKIN_TONE',
  CHOOSE_YOUR_DEFAULT_SKIN_TONE: 'CHOOSE_YOUR_DEFAULT_SKIN_TONE',
  MEDIUM_LIGHT_SKIN_TONE: 'MEDIUM_LIGHT_SKIN_TONE',
  MEDIUM_DARK_SKIN_TONE: 'MEDIUM_DARK_SKIN_TONE',
  REFRESH: 'REFRESH',
  GENERATED_SHA512_HASH: 'GENERATED_SHA512_HASH',
  RESULT: 'RESULT',
  RESULTS: 'RESULTS',
  RESULT_HISTORY: 'RESULT_HISTORY',
  FAIRNESS_P46: 'FAIRNESS_P46',
  CONVERSATION: 'CONVERSATION',
  NOT_ENOUGH_USERS: 'NOT_ENOUGH_USERS',
  PLAYER: 'PLAYER',
  FAIRNESS_P7: 'FAIRNESS_P7',
  YOUR_SESSION_WAS_INTERRUPTED: 'YOUR_SESSION_WAS_INTERRUPTED',
  LEADERBOARD: 'LEADERBOARD',
  TODAYS: 'TODAYS',
  FINAL: 'FINAL',
  NUMBER_OF_DAYS_TILL_PRMOTION_ENDS: 'NUMBER_OF_DAYS_TILL_PRMOTION_ENDS',
  VIEW_PROMOTION_DETAILS: 'VIEW_PROMOTION_DETAILS',
  POSITION: 'POSITION',
  POINTS: 'POINTS',
  PLEASE_VERIFY_YOUR_ACCOUNT: 'PLEASE_VERIFY_YOUR_ACCOUNT',
  ME: 'ME',
  PROMOTION_ENDED: 'PROMOTION_ENDED',
  YOUR_POSITION: 'YOUR_POSITION',
  COLLECTED_POINTS: 'COLLECTED_POINTS',
  CHOOSE_YOUR_AVATAR: 'CHOOSE_YOUR_AVATAR',
  MAX_WIN_NOTE: 'MAX_WIN_NOTE',
  WRONG_BET_AMOUNT: 'WRONG_BET_AMOUNT',
  MAX_FREE_BET_PAYOUT_NOTE: 'MAX_FREE_BET_PAYOUT_NOTE',
  WRONG_GAME_ID: 'WRONG_GAME_ID',
  AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  PLAYER_IS_BLOCKED: 'PLAYER_IS_BLOCKED',
  WRONG_CURRENCY: 'WRONG_CURRENCY',
  WRONG_WIN_AMOUNT: 'WRONG_WIN_AMOUNT',
  GAME_IS_BLOCKED: 'GAME_IS_BLOCKED',
  TRANSACTION_IS_ALREADY_EXISTS: 'TRANSACTION_IS_ALREADY_EXISTS',
  TRANSACTION_IS_ALREADY_CANCELED: 'TRANSACTION_IS_ALREADY_CANCELED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  TRANSACTION_NOT_FOUND: 'TRANSACTION_NOT_FOUND',
  TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
  GENERAL_ERROR: 'GENERAL_ERROR',
  INCORRECT_PARAMETERS_PASSED: 'INCORRECT_PARAMETERS_PASSED',
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
  MAX_STAKE_EXCEED: 'MAX_STAKE_EXCEED',
  BET_CANCELED_FOR_DELAY: 'BET_CANCELED_FOR_DELAY',
  WINTER_MODE: 'WINTER_MODE',
  FOOTBALL_MODE: 'FOOTBALL_MODE',
  VALENTINE_MODE: 'VALENTINE_MODE',
  MAINTENANCE_NOTE: 'MAINTENANCE_NOTE',
  AVAILABLE_TO_BET_MAX_AMOUNT_IS: 'AVAILABLE_TO_BET_MAX_AMOUNT_IS',
  INVALID_BET_AMOUNT_APPLIED: 'INVALID_BET_AMOUNT_APPLIED',
  PLAY_FOR_REAL: 'PLAY_FOR_REAL',
  GAME_RULES_P18: 'GAME_RULES_P18',
  GAME_RULES_P19: 'GAME_RULES_P19',
  SLOW_CONNECTION: 'SLOW_CONNECTION',
  MINIMUM_BET: 'MINIMUM_BET',
  MAXIMUM_BET: 'MAXIMUM_BET',
  AVAILABLE_BET_AMOUNT: 'AVAILABLE_BET_AMOUNT',
  AUTOGENERATED_SEED: 'AUTOGENERATED_SEED',
  PROFILE: 'PROFILE',
  HALLOWEEN_MODE: 'HALLOWEEN_MODE',
  LOADING: 'LOADING',
  NO_MATCHES_FOUND: 'NO_MATCHES_FOUND',
  SEARCH_FOR_GIFS: 'SEARCH_FOR_GIFS',
  FULLSCREEN: 'FULLSCREEN',
  AVATARS: 'AVATARS',
  WAIT: 'WAIT',
  YOUR_BET_IS_ACCEPTED: 'YOUR_BET_IS_ACCEPTED',
  BET_CANCELED: 'BET_CANCELED',
  WAIT_FOR_NEXT_ROUND: 'WAIT_FOR_NEXT_ROUND',
  UNDER_MAINTENANCE_IN_GAME: 'UNDER_MAINTENANCE_IN_GAME',
  UNDER_MAINTENANCE_DESC: 'UNDER_MAINTENANCE_DESC',
  MAX_LIMIT_NOTE: 'MAX_LIMIT_NOTE',
  SUCCESS: 'SUCCESS',
  SAVED_SEED: 'SAVED_SEED',
  MONEY_TRANSACTION_ERROR: 'MONEY_TRANSACTION_ERROR',
  GAME_RESULT: 'GAME_RESULT',
  MIN_ODD: 'MIN_ODD',
  Info: 'INFO',
  Home: 'HOME',
  CHECK: 'CHECK',
  FREE_BET: 'FREE_BET',
  Settings: 'SETTINGS',
  CancelationMessage_1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage_2: 'MALFUNCTION_MESSAGE_2',
  WinMoreWith: 'WIN_MORE_WITH',
  RtpPopUpDesc: 'RTP_POPUP_DESC',
  PlayAndWin: 'PLAY_AND_WIN',
  DontShowAgain: 'DONT_SHOW_AGAIN',
  HalfCashOut: 'HALF_CASH_OUT',
  CASHED: 'CASHED',
  RTP: 'RTP',
  Next: 'NEXT',
  SOON: 'SOON',
  Result: 'RESULT',
  CashOutFiftyDesc1: 'CASH_OUT_FIFTY_DESC_1',
  CashOutFiftyDesc2: 'CASH_OUT_FIFTY_DESC_2',
  NewFeature: 'NEW_FEATURE',
  About: 'ABOUT',
  Odds: 'ODDS',
  GameTypes: 'GAME_TYPES',
};

export const TranslationKeys = Object.assign(CoreTranslations, GameTranslationKeys);
